module.exports = __webpack_public_path__ + "media/components/icons/SVG/download-2ac1eabcc62ad76f3d7b92ca96fd6992.svg";